// extracted by mini-css-extract-plugin
module.exports = {"title":"WebPushNotificationEnableIcon_title__gMDWg","c-header__notification_icon":"WebPushNotificationEnableIcon_c-header__notification_icon__42qEY"};